import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import CustomSvg from './BaseIcon';
const PlusIcon = ({ className, testId = 'plusIcon', color, }) => {
    const { colors } = useTheme();
    const iconColor = color ? color : colors.interactive.brandColor;
    return (_jsx(CustomSvg, { className: className, "data-cy": testId, width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", children: _jsx("path", { d: "M1 8.5H16M8.5 1L8.5 16", stroke: iconColor, strokeWidth: "1.7", strokeLinecap: "round" }) }));
};
export default PlusIcon;
//# sourceMappingURL=PlusIcon.js.map